import { Container, Typography, Box, Button, Grid, useTheme } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import CheckIcon from "@mui/icons-material/Check";
import Reveal from "../../components/Reveal";
import { PageHero, Section, ZoomImage } from "../../components/layout";
import CONTACT_INFO from "../../constants/contactInfo";

const HERO_IMAGE =
    "https://ik.imagekit.io/cabanasdelcampo/exteriores/WhatsApp%20Image%202026-06-17%20at%2011.38.28%20(3).jpeg?updatedAt=1781707373435";

const experiencias = [
    {
        overline: "Aventura",
        titulo: "Paseos guiados en cuatriciclos",
        imagen: "https://ik.imagekit.io/cabanasdelcampo/20221106_121648.webp",
        alt: "Paseo guiado en cuatriciclo",
        items: [
            "Recorridos con dificultades controladas",
            "Miradores",
            "Vistas panorámicas de toda la Reserva Natural",
            "Descensos nocturnos",
            "Break con merienda",
            "Cuatriciclo Can Am 580",
        ],
        nota: "Consultá por tarifas para paseos individuales, en pareja o grupales.",
        videos: [
            { label: "Travesía", url: "https://youtube.com/shorts/QpeCArSx72c" },
            { label: "Paseo 1", url: "https://youtube.com/shorts/5GFviYvrtZc" },
            { label: "Paseo 2", url: "https://youtube.com/shorts/vDw2NzeFB44" },
        ],
    },
    {
        overline: "Bienestar",
        titulo: "Experiencia relax: masajes y limpieza facial",
        collage: [
            { src: "/images/experiencias/relax-sala.webp", alt: "Sala de masajes con velas" },
            { src: "/images/experiencias/relax-facial.jpg", alt: "Limpieza facial profunda" },
            { src: "/images/experiencias/relax-masaje.jpg", alt: "Masaje relajante" },
        ],
        intro: [
            "Un momento para desconectar, renovar energías y regalarte el bienestar que merecés.",
            "Disfrutá de una experiencia de relax en el entorno natural de Cabañas del Campo, combinando belleza y bienestar en una propuesta especial.",
        ],
        itemsTitulo: "Tu experiencia incluye",
        items: [
            "Limpieza facial profunda",
            "Masaje descontracturante o relajante, a elección",
        ],
        nota: "Con reserva previa a tu estadía. También podés contratar cada servicio por separado.",
        cierre: "Regalate una pausa, conectá con vos y disfrutá de una experiencia pensada para renovar cuerpo y mente.",
        videos: [],
    },
    {
        overline: "Para dos",
        titulo: "Cena romántica",
        imagen: "https://ik.imagekit.io/cabanasdelcampo/interiores/IMG_20251010_205335202_1.jpg?updatedAt=1760707529038",
        alt: "Cena romántica",
        intro: [
            "Una experiencia pensada para disfrutar en pareja, con ambientación especial y mesa preparada para la ocasión.",
        ],
        itemsTitulo: "Picada gourmet",
        items: [
            "5 variedades de fiambres",
            "3 variedades de quesos",
            "Maní saborizado",
            "Aceitunas verdes y negras",
            "Pan",
            "Vino o cerveza",
        ],
        nota: "Mesa preparada con detalles para la ocasión.",
        videos: [{ label: "Ver video", url: "https://www.instagram.com/reel/DQIUjqhErlV/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" }],
    },
    {
        overline: "Arte decorativo",
        titulo: "\"El Taller\" Casa de Arte",
        imagen: "/images/experiencias/taller-arte.jpg",
        alt: "\"El Taller\" Casa de Arte",
        intro: [
            "Un espacio creativo de arte decorativo en Athos Pampa, donde se crean piezas únicas, hechas con dedicación y pensadas para transformar cada rincón en un espacio con personalidad.",
            "Durante tu estadía podés sumarte a sus talleres o descubrir las piezas del taller y encontrar esa que más te representa.",
        ],
        itemsTitulo: "En el taller",
        items: [
            "Talleres y workshops de arte decorativo",
            "Piezas únicas hechas a mano",
            "Venta de insumos y arte",
        ],
        nota: "Consultá por fechas, horarios y disponibilidad de los talleres.",
        instagram: "https://www.instagram.com/eltaller.casadearte/",
        videos: [],
    },
    {
        overline: "Navidad y Año Nuevo",
        titulo: "Menú especial para fiestas",
        imagen: "https://ik.imagekit.io/cabanasdelcampo/AdobeStock_290851685.jpeg",
        alt: "Menú especial para fiestas",
        intro: [
            "En Cabañas del Campo, las fiestas se viven distinto. Con la calidez de sentirse en casa, pero con el disfrute de estar de vacaciones.",
            "Preparamos un menú especial para las fiestas, pensado para compartir, relajarse y celebrar sin preocupaciones.",
        ],
        items: [
            "Sabores caseros y detalles cuidados",
            "Clima único que invita a bajar el ritmo",
            "Brindar y disfrutar del momento",
        ],
        cierre: "Celebrar en el campo es disfrutar de lo simple, lo rico y lo verdadero. Navidad y Año Nuevo rodeados de naturaleza, descanso y buena mesa.",
        videos: [{ label: "Ver video", url: "https://youtube.com/shorts/kQ_LqQO9YI4" }],
    },
];

// Collage: la primera foto ocupa todo el alto, las otras dos se apilan al lado
const Collage = ({ images }) => {
    const [main, top, bottom] = images;
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridTemplateRows: "1fr 1fr",
                gap: { xs: 1.5, md: 2 },
                height: { xs: 340, md: 520 },
            }}
        >
            <ZoomImage sx={{ gridRow: "1 / 3", borderRadius: "20px" }}>
                <img src={main.src} alt={main.alt} loading="lazy" />
            </ZoomImage>
            <ZoomImage sx={{ borderRadius: "20px" }}>
                <img src={top.src} alt={top.alt} loading="lazy" />
            </ZoomImage>
            <ZoomImage sx={{ borderRadius: "20px" }}>
                <img src={bottom.src} alt={bottom.alt} loading="lazy" />
            </ZoomImage>
        </Box>
    );
};

const consultaLink = (titulo) =>
    `${CONTACT_INFO.whatsappLink}?text=${encodeURIComponent(
        `¡Hola! Quisiera consultar por la experiencia "${titulo}".`
    )}`;

const Experiencias = () => {
    const theme = useTheme();

    return (
        <Box>
            <PageHero image={HERO_IMAGE} imagePosition="center 60%" overline="Experiencias" title="Sumale algo especial a tu estadía">
                Servicios adicionales que podés sumar a tu estadía para hacerla aún más especial.
            </PageHero>

            {experiencias.map((exp, index) => {
                const imageRight = index % 2 === 1;
                return (
                    <Section
                        key={exp.titulo}
                        sx={{
                            py: { xs: 8, md: 12 },
                            mb: index === experiencias.length - 1 ? "-20px" : 0,
                            backgroundColor: index % 2 === 1 ? theme.palette.sand.light : "transparent",
                        }}
                    >
                        <Container>
                            <Grid
                                container
                                spacing={{ xs: 4, md: 10 }}
                                alignItems="center"
                                direction={{ xs: "column", md: imageRight ? "row-reverse" : "row" }}
                            >
                                <Grid item xs={12} md={6} sx={{ width: "100%" }}>
                                    <Reveal>
                                        {exp.collage ? (
                                            <Collage images={exp.collage} />
                                        ) : (
                                            <ZoomImage sx={{ height: { xs: 300, md: 520 } }}>
                                                <img src={exp.imagen} alt={exp.alt} loading="lazy" />
                                            </ZoomImage>
                                        )}
                                    </Reveal>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Reveal delay={120}>
                                        <Typography variant="overline" color="primary">
                                            {exp.overline}
                                        </Typography>
                                        <Typography variant="h3" sx={{ mt: 1, mb: 3 }}>
                                            {exp.titulo}
                                        </Typography>

                                        {exp.intro?.map((p) => (
                                            <Typography key={p} variant="body1" paragraph sx={{ color: "text.secondary" }}>
                                                {p}
                                            </Typography>
                                        ))}

                                        {exp.itemsTitulo && (
                                            <Typography variant="h6" sx={{ fontSize: "1.05rem", mt: 1, mb: 1 }}>
                                                {exp.itemsTitulo}
                                            </Typography>
                                        )}
                                        <Box
                                            component="ul"
                                            sx={{
                                                listStyle: "none",
                                                p: 0,
                                                m: 0,
                                                mb: 3,
                                                display: "grid",
                                                gridTemplateColumns: {
                                                    xs: "1fr",
                                                    sm: exp.items.length > 3 ? "repeat(2, 1fr)" : "1fr",
                                                },
                                                columnGap: 3,
                                            }}
                                        >
                                            {exp.items.map((item) => (
                                                <Box
                                                    component="li"
                                                    key={item}
                                                    sx={{ display: "flex", gap: 1.5, alignItems: "flex-start", py: 0.75 }}
                                                >
                                                    <CheckIcon fontSize="small" sx={{ color: "secondary.main", mt: 0.4 }} />
                                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                        {item}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>

                                        {exp.nota && (
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: "text.secondary",
                                                    pl: 2,
                                                    borderLeft: `3px solid ${theme.palette.primary.main}`,
                                                    mb: 3,
                                                }}
                                            >
                                                {exp.nota}
                                            </Typography>
                                        )}
                                        {exp.cierre && (
                                            <Typography
                                                sx={{
                                                    fontFamily: theme.typography.h1.fontFamily,
                                                    fontStyle: "italic",
                                                    fontSize: "1.15rem",
                                                    mb: 3,
                                                }}
                                            >
                                                {exp.cierre}
                                            </Typography>
                                        )}

                                        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
                                            <Button
                                                variant="contained"
                                                startIcon={<WhatsAppIcon />}
                                                href={consultaLink(exp.titulo)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Consultar
                                            </Button>
                                            {exp.instagram && (
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<InstagramIcon />}
                                                    href={exp.instagram}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Ver Instagram
                                                </Button>
                                            )}
                                            {exp.videos.map((v) => (
                                                <Button
                                                    key={v.url}
                                                    variant="outlined"
                                                    startIcon={<PlayArrowIcon />}
                                                    href={v.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {v.label}
                                                </Button>
                                            ))}
                                        </Box>
                                    </Reveal>
                                </Grid>
                            </Grid>
                        </Container>
                    </Section>
                );
            })}
        </Box>
    );
};

export default Experiencias;
